import React from "react";

const BulletStyle = {
  display: "inline-block",
  borderRadius: "50%",
};

/**
 * Bullet component for the SummaryWeek component to display a bullet point
 * @param {Object} props Props for the Bullet component
 * @param {string} props.color Color of the bullet (default: "#000")
 * @param {number} props.size Size of the bullet (default: 10)
 * @param {number} props.marginRight Margin right of the bullet (default: 8)
 * @returns {JSX.Element}
 */
const Bullet = ({ color = "#000", size = 10, marginRight = 8 }) => {
  return (
    <span
      style={{
        ...BulletStyle,
        width: size,
        height: size,
        backgroundColor: color,
        marginRight: marginRight,
      }}
    />
  );
};

export default Bullet;
